export default __webpack_public_path__ + "static/media/mantenimiento.65fce81d.png";